import App from './App'
import ReactDOM from 'react-dom'
import * as serviceWorker from './serviceWorker'
import {HelmetProvider} from 'react-helmet-async'
import {BrowserRouter} from 'react-router-dom'

import reportWebVitals from './reportWebVitals'

import 'nprogress/nprogress.css'

import 'react-datepicker/dist/react-datepicker.css'

import './style.css'

import {SidebarProvider} from './contexts/SidebarContext'

ReactDOM.render(
  <HelmetProvider>
    <SidebarProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </SidebarProvider>
  </HelmetProvider>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

// register() for pwa
serviceWorker.unregister()
